import Joi from 'joi';

import { AppSubjectEnum } from '../../../../shared/modules/authz/enums/app-subject.enum';
import { updateSupplierContactSchema } from '../../../contacts/validators/schemas/update-supplier-contact.schema';
import { createPoliciesAssignSchema } from '../../../policies/validators/schemas/policies-assign.schema';
import { createTagsSchema } from '../../../tags/validators/schemas/create-tags.schema';
import { SupplierTypeEnum } from '../../enums/supplier-type.enum';

/**
 * Schema for existing supplier record validation.
 */
export const updateSupplierSchema = () =>
  Joi.object({
    id: Joi.alternatives().conditional(Joi.any().valid(null), {
      then: Joi.invalid(null).messages({
        'any.invalid': 'validations|supplier-id|cannot-be-null',
      }),
      otherwise: Joi.number().required().messages({
        'any.required': 'validations|supplier-id|required',
        'number.base': 'validations|supplier-id|must-be-number',
      }),
    }),

    type: Joi.alternatives()
      .conditional(Joi.any().valid(null), {
        then: Joi.invalid(null).messages({
          'any.invalid': 'validations|supplier-type|cannot-be-null',
        }),
        otherwise: Joi.string()
          .valid(...Object.values(SupplierTypeEnum))
          .required()
          .messages({
            'any.required': 'validations|supplier-type|required',
            'any.only': 'validations|supplier-type|invalid-value',
          }),
      })
      .prefs({ abortEarly: true }),

    // Contact
    contact: updateSupplierContactSchema(),

    notes: Joi.string().allow(null, '').messages({
      'string.base': 'validations|supplier-notes|must-be-string',
    }),

    // Tags
    tags: createTagsSchema().messages({
      'array.base': 'validations|supplier-tags|invalid-value',
    }),

    policies: createPoliciesAssignSchema(AppSubjectEnum.SUPPLIER),

    files: Joi.any().allow(null),
  })
    // Ignore extra fields
    .unknown();
